import { FlowStepData } from "../FlowStepData";
import { MultiExecutableOutputDefinition } from "../../../Common/Execution/MultiExecutable";

export class ManyOutputTestStep extends FlowStepData {
    readonly __type: string = "many_output_test";

    paths: string[] = ["a", "b", "c", "d", "e", "f", "g", "h"];

    firstPathMustContinue: boolean = true;

    constructor() {
        super();
        this.name = "Many Output Test Step";
    }

    getStorageData(): object {
        let data = super.getStorageData();

        Reflect.set(data, "firstPathMustContinue", this.firstPathMustContinue);
        return data;
    }

    setStorageData(data: object) {
        super.setStorageData(data);

        this.firstPathMustContinue = Reflect.get(data, "firstPathMustContinue");
    }

    getOutcomes(): MultiExecutableOutputDefinition[] {
        return this.paths.map((value) => {
            return new MultiExecutableOutputDefinition(value);
        });
    }
}
